import { Endpoint, PollQrRequest, PollQrResponse } from '../class/class';
import { httpRequest } from '../utils/utils';

export class SignPollQr extends Endpoint {
  static endpoint = 'qsl_sign_pollqr';

  constructor() {
    super();
  }

  async doPollQr(qrId: string): Promise<PollQrResponse> {
    const resp = await httpRequest<PollQrResponse>(
      `${this.baseUrl}${SignPollQr.endpoint}`,
      new PollQrRequest(qrId),
    );
    return new PollQrResponse(resp.json);
  }
}
